export default __webpack_public_path__ + "static/media/EconomicsGoodsService_00.52269be2.png";